export const DOCUMENTATION_URL = `${process.env.GATSBY_DOCUMENTATION_URL}`;

export const DOCUMENTATION_CALLBACK_URL = `${process.env.GATSBY_DOCUMENTATION_URL}/callback`;

export const GITHUB_BASE_API = "https://api.github.com/repos/:user/:repo";

export const GITHUB_ZIP_API =
  "https://api.github.com/repos/:user/:repo/zipball/:branch_name";

export const GITHUB_REPO_README_API =
  "https://api.github.com/repos/:user/:repo/readme";
